import { render, staticRenderFns } from "./ProviderCrudForm.vue?vue&type=template&id=62e3dd64&"
import script from "./ProviderCrudForm.vue?vue&type=script&lang=js&"
export * from "./ProviderCrudForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports